import { IApplicationState, TThunkDispatch } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/applicationContext';
import { createReduxStore } from '../../../shared/utils/redux';
import { loadReviews } from '../../../shared/actions/reviews/loadReviews';

export function createApplicationState(context: IApplicationContext) {
  const { config } = context;

  const initialState = config.getStrict<IApplicationState>('initialState');

  const store = createReduxStore(initialState, true, context);
  (store.dispatch as TThunkDispatch)(loadReviews({ page: 0, getAllItems: true }));

  return store;
}
